"use client";

import { word } from "@perksmith/api-client";
import { useSyncExternalStore } from "react";

import { isMaintenanceHeld, subscribeMaintenanceHeld } from "@/lib/api/maintenanceHold";

/**
 * A thin, quiet line across the top while the edge holds the app for planned maintenance.
 * Never a block: sales keep going and every call keeps its own offline handling underneath.
 */
export function MaintenanceBanner() {
  const held = useSyncExternalStore(subscribeMaintenanceHeld, isMaintenanceHeld, () => false);
  if (!held) return null;
  return (
    <p role="status" className="border-b border-stroke-weak bg-fill-neutral-weak px-4 py-2 text-center text-sm font-semibold text-text-weak">
      {word("scene.maintenance.till.banner")}
    </p>
  );
}
